import { apiGet, apiPost } from '../_common';

export default {
  searchPending(query) {
    return apiGet('/magenta/fiscal/purchase-invoice-item/pending', query).then(result => result.response);
  },
  suggestions(itemId) {
    return apiGet(`/magenta/fiscal/purchase-invoice-item/${itemId}/suggestions`).then(result => result.response);
  },
  // request: { productId, unitsPerSupplierUnit, rememberSupplierCode, addBarcode }
  // Answers { item, barcode, barcodeOwnerProductId, matchedByBarcode }
  match(itemId, request) {
    return apiPost(`/magenta/fiscal/purchase-invoice-item/${itemId}/match`, request).then(result => result.response);
  },
  ignore(itemId, rememberSupplierCode) {
    return apiPost(`/magenta/fiscal/purchase-invoice-item/${itemId}/ignore`, { rememberSupplierCode })
      .then(result => result.response);
  },
  // Takes the item out of everything without remembering anything about its supplier code
  disregard(itemId) {
    return apiPost(`/magenta/fiscal/purchase-invoice-item/${itemId}/disregard`, {}).then(result => result.response);
  },
  unmatch(itemId, forgetSupplierCode) {
    return apiPost(`/magenta/fiscal/purchase-invoice-item/${itemId}/unmatch`, { forgetSupplierCode })
      .then(result => result.response);
  },
  matchPending() {
    return apiPost('/magenta/fiscal/purchase-invoice-item/match-pending', {}).then(result => result.response);
  },
  ncmDivergences() {
    return apiGet('/magenta/fiscal/ncm-divergence').then(result => result.response);
  },
  // Stops showing the product as divergent while its invoices state invoiceNcm
  keepProductNcm(productId, invoiceNcm) {
    return apiPost(`/magenta/fiscal/ncm-divergence/${productId}/keep`, { invoiceNcm }).then(result => result.response);
  },
};
